import {IComponentController} from "angular";
import {BrandServiceName, ToastNotificationServiceName} from "../../../utils/names/serviceNames";
import {Brand} from "../../../brand_service/model/Brand";
import {BrandService} from "../../../brand_service/service/BrandService";
import './delete.brand.component.scss'
import {ToastNotificationService} from "../../../utils/ToastNotificationService";

export class DeleteBrandDialogComponent implements IComponentController {

    public static instance = (brand: Brand): angular.material.IDialogOptions => ({
        template: require('./delete.brand.dialog.component.html'),
        controller: [BrandServiceName,
            '$mdDialog',
            ToastNotificationServiceName,
            'brand',
            DeleteBrandDialogComponent],
        controllerAs: 'ctrl',
        locals: {
            brand: brand
        }
    });


    constructor(private brandService: BrandService,
                private $mdDialog: angular.material.IDialogService,
                private toastNotificationService: ToastNotificationService,
                private brand: Brand) {
        this.showLoader = false;
    }

    private showLoader: boolean;

    private deleteBrand = () => {
        this.showLoader = true;
        this.brandService.deleteBrand(this.brand)
            .then(resp => {
                    this.showLoader = false;
                    if (resp.status === 200) {
                        this.handleStatusOk();
                    } else if (resp.status === 400) {
                        this.handleStatusBadRequest(resp.data);
                    } else {
                        this.handleStatusUnknown(resp);
                    }
                },
                () => {
                    this.showLoader = false;
                    this.toastNotificationService.generateErrorMessage('Failed to delete brand');
                    this.$mdDialog.cancel();
                });
    };

    private handleStatusOk() {
        this.toastNotificationService.generateSuccessMessage('Brand ' + this.brand.name + ' deleted');
        this.$mdDialog.hide(this.brand);
    }

    private handleStatusBadRequest(data) {
        if (data != null && data.message != null) {
            this.toastNotificationService.generateErrorMessage(data.message);
        } else {
            this.toastNotificationService.generateErrorMessage('Failed to delete brand');
        }
        this.$mdDialog.cancel();

    }

    private handleStatusUnknown(resp: angular.IHttpResponse<unknown>) {
        console.log(resp);
        this.toastNotificationService.generateErrorMessage('Failed to delete brand');
        this.$mdDialog.cancel();
    }

    private cancelDelete = () => {
        this.$mdDialog.cancel();
    };
}